import { push } from 'redux-first-history';
import queryString from 'query-string';
import selectors from '../../root/shared/root';
import { getUrlString } from '../../utils/shared/urlUtils';

const openProbeDetails = (resultId, bookId) => async (dispatch, getState) => {
    const state = getState();
    const { pathname, search } = selectors.getLocation(state);
    if (resultId) {
        dispatch(
            push(
                getUrlString(pathname, {
                    ...queryString.parse(search),
                    resultId,
                    bookId,
                }),
            ),
        );
    }
};

export default openProbeDetails;
